<template>
	<vx-card
		:title="company.id > 0 ? $t('CompanyFormTitleUpdate') : $t('CompanyFormTitleCreate')"
		class="mt-5 create-form-company"
		:cardBorder="true"
		:noShadow="true"
	>
		<vs-row vs-w="12">
			<vs-col vs-lg="12" vs-sm="12" vs-xs="12">
				<!-- COMPANY NAME -->
				<div class="vx-row mb-6">
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							name="name"
							class="w-full"
							icon-pack="feather"
							icon="icon-briefcase"
							icon-no-border
							:label-placeholder="$t('CompanyCreate.CompanyName')"
							v-model="company.name"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
					</div>
					<!-- ADDRESS -->
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							name="address"
							type="text"
							class="w-full"
							icon-pack="feather"
							icon="icon-mail"
							icon-no-border
							:label-placeholder="$t('CompanyCreate.Address')"
							v-model="company.address"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('address')">{{
							errors.first("address")
						}}</span>
					</div>
				</div>

				<div class="vx-row mb-6">
					<!-- PHPONE -->
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							type="number"
							name="phone"
							class="w-full"
							icon-pack="feather"
							icon="icon-phone"
							icon-no-border
							:label-placeholder="$t('CompanyCreate.Phone')"
							v-model="company.phone"
							v-validate="'required|numeric'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('phone')">{{
							errors.first("phone")
						}}</span>
					</div>

					<!-- NIT -->
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							name="nit"
							type="text"
							class="w-full"
							icon-pack="feather"
							icon="icon-lock"
							icon-no-border
							label-placeholder="Nit"
							v-model="company.nit"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('nit')">{{ errors.first("nit") }}</span>
					</div>
				</div>

				<div class="vx-row mb-6">
					<!-- DATE INIT -->
					<div class="vx-col w-full md:w-1/2">
						<small class="date-label">{{ $t("CompanyCreate.InitDate") }}</small>
						<datepicker
							:language="$vs.rtl ? langEn : langEs"
							name="date_init"
							v-model="company.date_init"
							v-validate="'required|truthy_date_init'"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('date_init')">{{
							errors.first("date_init")
						}}</span>
					</div>

					<!-- DATE END -->
					<div class="vx-col w-full md:w-1/2">
						<small class="date-label">{{ $t("CompanyCreate.EndDate") }}</small>
						<datepicker
							:language="$vs.rtl ? langEn : langEs"
							v-model="company.date_end"
							:disabledDates="disabledDatesTo"
							v-validate="'required|truthy'"
							name="date_end"
						></datepicker>
						<span class="text-danger text-sm" v-show="errors.has('date_end')">{{
							errors.first("date_end")
						}}</span>
					</div>
				</div>

				<!-- DCONTACT PERSON -->
				<div class="vx-row mb-6">
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							name="contac_persons"
							type="text"
							class="w-full"
							icon-pack="feather"
							icon="icon-user"
							icon-no-border
							:label-placeholder="$t('CompanyCreate.ContactPerson')"
							v-model="company.contac_persons"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm" v-show="errors.has('contac_persons')">{{
							errors.first("contac_persons")
						}}</span>
					</div>

					<!-- DESCRIPTION -->
					<div class="vx-col w-full md:w-1/2">
						<vs-input
							type="text"
							class="w-full"
							icon-pack="feather"
							icon="icon-message-square"
							icon-no-border
							:label-placeholder="$t('CompanyCreate.Description')"
							v-model="company.description"
						/>
					</div>
				</div>

				<div class="vx-row mb-6">
					<div class="vx-col w-full md:w-1/3">
						<label class="vs-input--label">{{ $t("CompanyCreate.Country") }}</label>
						<v-select
							v-model="selectedCountry"
							v-validate="'required'"
							name="country"
							:placeholder="$t('Select')"
							:clearable="false"
							:options="countriesOptions"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
								<template v-else>
									{{ $t("NoResultsFound") }}
								</template>
							</template>
						</v-select>
						<span class="text-danger text-sm" v-show="errors.has('country')">{{
							$t("CompanyModule.Form.ValidMessages.Country")
						}}</span>
					</div>
					<div class="vx-col w-full md:w-1/3">
						<label class="vs-input--label">{{ $t("Divipola.Department") }}</label>
						<v-select
							v-model="selectedDepartment"
							name="departments"
							:loading="departments.length <= 0 && selectedCountry ? true : false"
							:clearable="false"
							:disabled="departments.length <= 0"
							:options="departments"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
						<span class="text-danger text-sm" v-show="errors.has('departments')">{{
							$t("ResourceModule.BasicInfoForm.ValidMessages.Departament")
						}}</span>
					</div>
					<div class="vx-col w-full md:w-1/3">
						<label class="vs-input--label">{{ $t("City") }}</label>
						<v-select
							v-model="selectedCity"
							v-validate="'required'"
							name="cities"
							:loading="cities.length <= 0 && selectedDepartment && selectedCountry ? true : false"
							:disabled="cities.length <= 0"
							:clearable="false"
							:options="cities"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
						>
							<template v-slot:no-options="{search, searching}">
								<template v-if="searching">
									{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
								</template>
							</template>
						</v-select>
						<span class="text-danger text-sm" v-show="errors.has('cities')">{{
							$t("CompanyModule.Form.ValidMessages.City")
						}}</span>
					</div>
				</div>
			</vs-col>
		</vs-row>
	</vx-card>
</template>
<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
import {dict} from "@/models/CompanyValidator.js";
import Commons from "@/helpers/commons.js";
import DateUtils from "@/helpers/DateUtils.js";
import moduleCompany from "@/store/company/moduleCompany.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import Company from "@/models/Company.js";

// register custom messages
Validator.localize("en", dict);

export default {
	name: "CompanyForm",
	components: {
		Datepicker,
		vSelect,
	},
	props: {
		isEditActive: {
			type: Boolean,
			required: true,
		},
		data: {
			type: Company,
			default: () => {},
		},
	},
	data() {
		return {
			company: this.data,
			langEs: es,
			langEn: en,
			countries: [],
			cities: [],
			departments: [],
			selectedCountry: null,
			selectedCity: null,
			selectedDepartment: null,
			resource: {
				additional_info: {},
				email: "",
				identification: "",
				lastname: "",
				name: "",
				role_id: 1,
				status_id: 2,
				typology_id: 0,
				username: "",
			},
			selectedRelationship: {label: "All", value: "all"},
		};
	},
	methods: {
		chekFormValid() {
			return (
				!this.errors.any() &&
				this.company.name.length > 0 &&
				this.company.address.length > 0 &&
				this.company.phone.length > 0 &&
				this.company.nit.length > 0 &&
				this.company.init_date !== "" &&
				this.company.end_date !== "" &&
				this.company.city.length > 0 &&
				this.company.country.length > 0
			);
		},
		formatDates(dateString) {
			// 'Tue, 18 Mar 2025 19:35:52 GMT'
			const newDate = new Date(dateString);
			return DateUtils.toDefaultDateTime(newDate, "YYYY-MM-DD");
		},
		submitForm() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					if (this.company.id > 0) {
						this.updateData();
					} else {
						this.saveData();
					}
				} else {
					this.$vs.notify({
						color: "warning",
						title: this.$t("MissingFieldTitle"),
						text: this.$t("MissingField"),
					});
				}
			});
		},
		saveData() {
			this.company.date_init = this.formatDates(this.company.date_init);
			this.company.date_end = this.formatDates(this.company.date_end);
			delete this.company.id;
			Commons.openLoadingButton.call(this, "btn-submit-company");
			this.$store
				.dispatch("moduleCompany/addItemCompany", this.company)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyCreate"),
						text: this.$t("TextConfirmCompanyCreate"),
					});
					Commons.closeLoadingButton.call(this, "btn-submit-company");
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-submit-company");
					console.error(err);
				});
		},
		updateData() {
			this.company.date_init = this.formatDates(this.data.date_init);
			this.company.date_end = this.formatDates(this.data.date_end);
			Commons.openLoadingButton.call(this, "btn-submit-company");
			this.$store
				.dispatch("moduleCompany/updateItem", this.company)
				.then((res) => {
					this.$vs.notify({
						color: "success",
						title: this.$t("TitleConfirmCompanyUpdate"),
						text: this.$t("TextConfirmCompanyUpdate"),
					});
					Commons.closeLoadingButton.call(this, "btn-submit-company");
					this.$emit("changeActiveTabEmit", 0);
				})
				.catch((err) => {
					Commons.closeLoadingButton.call(this, "btn-submit-company");
					console.error(err);
				});
		},
		resetForm() {
			this.company = new Company({});
			setTimeout(() => {
				this.errors.clear();
			}, 100);
		},
		fillForm() {
			if (this.company.id > 0) {
				if (this.company.country !== undefined) this.getDepartments(this.company.country);
				if (this.company.department) this.getCities(this.company.department);
				this.selectedCountry = this.company.country;
				this.selectedCity = this.company.city;
				this.selectedDepartment = this.company.department;
			} else {
				this.resetForm();
			}
		},
		cancelEdit() {
			this.$emit("changeActiveTabEmit", 0);
		},
		getCities(department) {
			this.$store
				.dispatch("moduleCommon/getCitiesByDeparment", {
					name: department ? department.replaceAll(",", "") : "",
					country: this.company.country,
				})
				.then((res) => {
					this.cities = Commons.generateSelectOptios(res.data, "city_name", "city_name");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getDepartments(countryName) {
			this.$store
				.dispatch("moduleCommon/getDepartments", {name: countryName})
				.then((res) => {
					this.departments = Commons.generateSelectOptios(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		getDepartmentsByCityCountry() {
			this.$store
				.dispatch("moduleCommon/getDepartmentsByCityCountry", {
					country: this.company.country,
					city: this.company.city,
				})
				.then((res) => {
					this.departments = Commons.generateSelectOptios(res.data, "department_name", "department_name");
				})
				.catch((error) => {
					console.error(error);
				});
		},
		validateEndDate(value, args) {
			if (typeof value === "object") {
				return new Date(this.company.date_init).getTime() < value.getTime();
			}
			return true;
		},
		initDateValidator(value, args) {
			if (typeof value === "object" && typeof this.company.date_end === "object") {
				return new Date(this.company.date_end).getTime() > value.getTime();
			}
			return true;
		},
		getDataFormCompany() {
			this.$emit("getFormDataCompanyEmit", this.company);
		},
	},
	computed: {
		countriesOptions() {
			return Commons.generateSelectOptios(
				this.$store.state.moduleCommon.countries,
				"country_name",
				"country_name"
			);
		},
		validateForm() {
			return !this.errors.any();
		},
		titte() {
			return this.$t("Company");
		},
		isFormValid: {
			get() {
				return (
					!this.errors.any() &&
					this.company.name.length > 0 &&
					this.company.address.length > 0 &&
					this.company.phone.length > 0 &&
					this.company.nit.length > 0 &&
					this.company.init_date !== "" &&
					this.company.end_date !== ""
				);
			},
			set(val) {},
		},
		disabledDatesTo() {
			return {to: new Date(this.company.date_init)};
		},
		disabledDatesFrom() {
			return {from: new Date(this.company.date_init)};
		},
		relationshipOptions() {
			return [
				{label: "All", value: "all"},
				{label: "Mono", value: "mono"},
				{label: "Multi", value: "multi"},
			];
		},
		relationshipDescriptionText() {
			return this.$t(`CompanyModule.${this.selectedRelationship.label}Description`);
		},
	},
	mounted() {
		this.fillForm();
	},
	created() {
		this.today = DateUtils.today();
		if (!moduleCompany.isRegistered) {
			this.$store.registerModule("moduleCompany", moduleCompany);
			moduleCompany.isRegistered = true;
		}

		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}

		if (this.$store.state.moduleCommon.countries.length <= 0) {
			this.$store.dispatch("moduleCommon/getCountries").catch((error) => {
				console.error(error);
			});
		}
		Validator.extend("truthy", this.validateEndDate);
		Validator.extend("truthy_date_init", this.initDateValidator);
	},
	watch: {
		"company.date_init"(val) {
			this.errors.clear();
			if (typeof val === "object") {
				setTimeout(() => {
					this.validateEndDate(new Date(this.company.date_end));
				}, 50);
			}
		},
		"company.date_end"(val) {
			this.errors.clear();
			setTimeout(() => {
				this.initDateValidator(new Date(this.company.date_init));
			}, 50);
		},
		selectedCity(object) {
			if (typeof object === "object" && object) {
				this.company.city = object.label;
				this.getDepartmentsByCityCountry();
			} else {
				this.cities.push({
					value: object,
					label: object,
				});
				this.company.city = object;
			}
		},
		selectedCountry(object) {
			if (!this.isEditActive) {
				this.selectedDepartment = null;
				this.selectedCity = null;
			}
			if (typeof object === "object") {
				this.company.country = object.label;
				this.getDepartments(object.label);
			} else {
				this.company.country = object;
			}
		},
		selectedDepartment(object) {
			if (typeof object === "object" && object) {
				this.company.department = object.label;
				this.getCities(object.value);
			} else {
				this.departments.push({
					value: object,
					label: object,
				});
				this.company.department = object;
			}
		},
		selectedRelationship(val) {
			this.company.realtionship_vp = val.value;
		},
	},
};
</script>
<style lang="scss" scoped>
.create-form-company {
	height: 100%;
}
</style>
